import React, { useCallback, useEffect } from "react";
import { observer } from "mobx-react";

import { IDeviceTeleopConfiguration } from "@formant/core/model/IDeviceTeleopConfiguration";

import { track } from "../../analytics";
import { useStores } from "../../context/StoreContext";
import { TeleopArmSwitch } from "./TeleopArmSwitch";

export interface IConnectedTeleopArmSwitchProps {
    configuration?: IDeviceTeleopConfiguration;
}

export const ConnectedTeleopArmSwitch = observer(
    function ConnectedTeleopArmSwitch(props: IConnectedTeleopArmSwitchProps) {
        const { configuration } = props;

        const { operateStore } = useStores();

        if (!configuration) {
            return null;
        }

        const { armSwitchEnabled, showArmSwitch, tryingToInteract } =
            operateStore;

        const handleToggle = useCallback(() => {
            operateStore.armSwitchEnabled = !operateStore.armSwitchEnabled;
            operateStore.tryingToInteract = false;
            track("Toggle Joystick safety switch", {
                state: operateStore.armSwitchEnabled ? "Locked" : "Unlocked",
            });
        }, [operateStore]);

        useEffect(() => {
            // Disable on unmount
            return () => {
                operateStore.armSwitchEnabled = false;
                operateStore.tryingToInteract = false;
            };
        }, [operateStore]);

        return (
            <TeleopArmSwitch
                visible={showArmSwitch}
                enabled={armSwitchEnabled}
                highlight={tryingToInteract}
                onToggle={handleToggle}
            />
        );
    },
);
